import { Outlet } from 'react-router-dom';

export function Frame({Header}) {
    return(
        <div className="page">
            <div> <Header/> </div>
            <main className="silent-scroll">
                <Outlet/>
            </main>
        </div>
    )
}

export function FullScreenFrame({Header}) {
    return(
        <div className="page relative">
            <div className='w-100 highest-layer' style={{position: 'fixed'}}> <Header/> </div>
            <main className="silent-scroll fh-100" style={{paddingTop: "98px"}}>
                <Outlet/>
            </main>
        </div>
    )
}